import { EmptyState } from '@/common/components/features/empty-state';

const PodcastLoader = () => {
  return (
    <div className='flex flex-col w-full h-full gap-6' data-testid='podcast-loader'>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col sm:items-center sm:justify-between sm:flex-row'>
          <div
            className='w-56 h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse'
            data-testid='podcast-loader-title'
          ></div>
        </div>

        <span className='flex items-center'>
          <span className='h-px flex-1 bg-border-neutral'></span>
        </span>
      </div>
      <div>
        <EmptyState
          image={{
            src: '/images/loader-image.webp',
            alt: 'Pessoas em um parque praticando ioga, pedalando e correndo, cercadas por natureza e animais.',
            srcSet:
              '/images/optimized/loader-image-448w.webp 448w, /images/optimized/loader-image-896w.webp 896w, /images/optimized/loader-image-1344w.webp 1344w, /images/optimized/loader-image-1792w.webp 1792w, /images/optimized/loader-image-2240w.webp 2240w',
            sizes:
              '(max-width: 768px) 448px, (max-width: 1024px) 896px, (max-width: 1280px) 1344px, (max-width: 1536px) 1792px, 2240px',
            priority: true,
          }}
          title='Carregando seu podcast...'
          description='Estamos preparando todas as informações. Isso pode levar alguns segundos.'
        />
      </div>
    </div>
  );
};

export { PodcastLoader };
